<bit-card
  class="tw-flex tw-flex-col tw-items-center tw-border tw-rounded-xl tw-border-solid tw-border-secondary-100 tw-bg-background tw-gap-5 tw-p-6 tw-shadow-sm"
>
  <div
    class="tw-flex tw-justify-center tw-items-center tw-bg-bg-warning-medium tw-p-2 tw-size-12 tw-border tw-rounded-lg tw-border-bg-warning-soft"
  >
    <bit-icon [name]="icon()" [class]="iconClass() + ' tw-flex-shrink-0 tw-aspect-square'" />
  </div>

  <div class="tw-flex tw-flex-col tw-gap-2 tw-align-middle tw-justify-center tw-text-center">
    <h2 bitTypography="h4">{{ title() }}</h2>
    <p bitTypography="body2" class="tw-max-w-lg tw-text-main tw-m-0">{{ description() }}</p>
  </div>

  @if (buttonText(); as buttonText) {
    <button
      bitButton
      buttonType="secondary"
      type="button"
      [loading]="loading()"
      (click)="actionClicked.emit()"
    >
      {{ buttonText }}
    </button>
  }
</bit-card>
